// extracted by mini-css-extract-plugin
module.exports = {"img":"PoiosBackground_img__w5SCC"};